'use client';

import { useModalQueue } from '$util/hooks/useModalQueue';
import { Icon } from '@/components/atoms/Icon';
import FaqAccordionItems from '@/components/molecules/FaqAccordionItems';
import styles from './index.module.scss';

interface ContentProps {
  subtitle: string;
  uri: string;
}

interface ItemProps {
  title: string;
  content: ContentProps[];
}

interface FaqBreadcrumbLinkProps {
  slug: string;
  items: ItemProps[];
  title: string;
  backToFAQ: string;
}

function findSubtitleByUri(items: ItemProps[], uri: string): string {
  for (const item of items) {
    for (const content of item.content) {
      if (content.uri.includes(uri)) {
        return content.subtitle;
      }
    }
  }
  return 'Article';
}

export default function FaqBreadcrumbLink({
  slug,
  items,
  title,
  backToFAQ,
}: FaqBreadcrumbLinkProps): JSX.Element {
  const [, queueModal] = useModalQueue();

  const toggleModal = () => {
    queueModal([
      <div key="modal-content" className={styles.modalContent}>
        <a href="/faq" className={styles.faqBack}>
          <Icon
            id="arrows/arrow-left"
            className={styles.arrowLeft}
            color="#6D7287"
            width={16}
            height={16}
            legacy={false}
          />
          {backToFAQ}
        </a>
        <h2>{title}</h2>
        <FaqAccordionItems items={items} />
      </div>,
      'modal-drawer',
    ]);
  };

  const articleTitle = findSubtitleByUri(items, slug);

  return (
    <div className={styles.breadcrumb}>
      <a href="/faq">FAQ</a>
      <Icon id="arrows/chevron-down" className={styles.arrowIcon} legacy={false} width={16} height={16} />
      <button onClick={toggleModal} type="button">
        {articleTitle}
      </button>
    </div>
  );
}

FaqBreadcrumbLink.displayName = 'FaqBreadcrumbLink';
